import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

export const CTA = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16 md:py-20 bg-white" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="relative bg-slate-900 rounded-2xl overflow-hidden"
        >
          {/* Background pattern */}
          <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px]"></div>
          
          {/* Glow effects */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/20 rounded-full blur-[100px]"></div>
          <div className="absolute bottom-0 left-0 w-72 h-72 bg-blue-600/10 rounded-full blur-[80px]"></div>

          <div className="relative z-10 px-6 py-12 md:px-12 md:py-16 text-center">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 tracking-tight" data-testid="cta-title">
              {t('cta_title')}
            </h2>
            <p className="text-base md:text-lg text-slate-300 max-w-2xl mx-auto mb-10">
              {t('cta_subtitle')}
            </p>
            <Button 
              asChild
              size="lg"
              className="bg-white text-slate-900 hover:bg-slate-100 rounded-md px-10 py-6 text-base font-semibold transition-all hover:shadow-lg"
              data-testid="cta-button"
            >
              <a href="https://logirent.ch/" target="_blank" rel="noopener noreferrer">
                {t('cta_button')}
                <ArrowRight className="ml-2 w-5 h-5" />
              </a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
